// this script customises the Gorgias chat box font - Brandon
// to do: contact us form styling
var initGorgiasChatPromise = window.GorgiasChat
  ? window.GorgiasChat.init()
  : new Promise(function (resolve) {
      window.addEventListener('gorgias-widget-loaded', function () {
        resolve();
      });
    });

initGorgiasChatPromise.then(function () {
  GorgiasChat.on('widget:opened', function () {
    var timer = setInterval(function () {
      var chatWindowHead = document
        .querySelector('#gorgias-chat-container')
        ?.querySelector('#chat-window')
        ?.contentWindow.document.querySelector('head');
      if (![...chatWindowHead?.children].some((x) => x.getAttribute('data-emotion'))) {
        return;
      }
      clearInterval(timer);
      var link = document.createElement('link');
      link.type = 'text/css';
      link.rel = 'stylesheet';
      link.href = 'https://use.typekit.net/mnt0hxn.css';
      chatWindowHead.appendChild(link);
      var chatStyle = document.createElement('style');
      chatStyle.textContent =
        'body, p, div, span, h3, h2, h1, p, b, h1, h2, h3, h4, h5, h6, a, button, input { font-family: typeka, serif !important; } ';
      chatWindowHead.appendChild(chatStyle);
    }, 50);
  });
});